import React, { useState } from "react";
import "./ServiceTabs.css";

// Import your SVG/PNG assets
import ai from "../../assests/aiml-img-implimentation.svg";
import datamanagement from "../../assests/data-management.svg";
import cybersecurity from "../../assests/custom-software-development.svg";
import arvr from "../../assests/ar-vr-img.svg";
import cloud from "../../assests/cloude-img.svg";
import iot from "../../assests/robotic-img.svg";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

// Service data with image paths
const serviceData = [
  {
    id: 1,
    title: " AI & ML Automation",
    description:
      "Leverage AI and automation to boost efficiency and innovation. Deploy scalable AI solutions, automate processes, and generate actionable insights.",
    image: ai,
    link:"/AI-ML-Solution"
  },
  {
    id: 2,
    title: "Digital Engineering",
    description:
      "Deliver scalable software and robust enterprise systems. From development and testing to architecture and project management, ensure successful digital transformation.",
    image: cloud,
    link:"/Custom-Software"
  },
  {
    id: 3,
    title: "Cloud & DevOps",
    description:
      "Optimize, secure, and modernize your cloud infrastructure. Accelerate software delivery with DevOps automation while reducing costs and maintaining reliable operations.",
    image: cybersecurity,
    link:"/cloud-services"
  },
  {
    id: 4,
    title: "Data & Analytics",
    description:
      "Turn data into actionable insights. From strategy to advanced reporting, we ensure high-quality, integrated data that drives informed decisions.",
    image: datamanagement,
    link:"/Data-Management"
  },
  {
    id: 5,
    title: "Extended Reality (AR/VR)",
    description:
      "Enhance learning, collaboration, and visualization with immersive AR/VR solutions. Build custom experiences and interactive data visualizations for impactful outcomes.",
    image: arvr,
    link:"/ar/vr-services"
  },
  {
    id: 6,
    title: "IoT & Robotic Automation",
    description:
      "Connect, monitor, and automate operations with IoT and RPA. Gather real-time data, implement predictive maintenance, and streamline workflows.",
    image: iot,
    link:"/IOT-services"
  },
];

const ServiceTabs: React.FC = () => {
  const navigate =useNavigate()
  const [activeIndex, setActiveIndex] = useState(0);
  const activeService = serviceData[activeIndex];

    const handlePrevious = () => {
    setActiveIndex((prevIndex) => 
      prevIndex === 0 ? serviceData.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => 
      prevIndex === serviceData.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
 <div className="service-wrapper" id="services">
      <div className="service-container">
        {/* Header */}
        <div className="service-header">
          <h3 className="service-h3"><span className="dot-1"></span> Our Service</h3>
          <h1 className="services-h1">AI-Enhanced Software for Every Industry</h1>
        </div>

        {/* Main */}
        <div className="service-main">
          {/* Sidebar Tabs with Separated Navigation */}
          <div className="tabs-section">
            {/* Left Navigation Button */}
            <button 
              className="nav-arrow nav-arrow-left" 
              onClick={handlePrevious}
              aria-label="Previous service tab"
            >
              <ChevronLeft size={18} />
            </button>

            {/* Tabs Container */}
            <div className="services-tabs">

              {/* Desktop: Show All Tabs */}
              <div className="desktop-tabs">
                {serviceData.map((service, index) => (
                  <div
                    key={service.id}
                    className={`service-tabs ${
                      index === activeIndex ? "active" : ""
                    }`}
                    onClick={() => setActiveIndex(index)}
                  >
                    <span className="tab-id">
                      {String(service.id).padStart(2, "0")}
                    </span>
                    <span>{service.title}</span>
                  </div>
                ))}
              </div>

              {/* Mobile: Show Only Active Tab */}
              <div className="mobile-tabs">
                <div className="service-tabs active">
                  <span className="tab-id">
                    {String(activeService.id).padStart(2, "0")}
                  </span>
                  <span>{activeService.title}</span>
                </div>
              </div>
            </div>

            {/* Right Navigation Button */}
            <button 
              className="nav-arrow nav-arrow-right" 
              onClick={handleNext}
              aria-label="Next service tab"
            >
              <ChevronRight size={18} />
            </button>
          </div>

          {/* Active Card */}
          <div className="services-cards">
            <div className="card-content">
              <div className="card-text">
                <h5>{activeService.title}</h5>
                <p>{activeService.description}</p>
          <button
            className="read-more"
            onClick={() => navigate(activeService.link)}
          >
            Read More →
          </button>
              </div>
              <div className="card-image">
                <img src={activeService.image} alt={activeService.title} />
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

  );
};

export default ServiceTabs;
